module.exports = __webpack_public_path__ + "images/1-h827d4dff3c94aea3549678088348f9ff.svg";